import { loginReducer, AUTH_SLICE } from 'Services/auth.service';
import appReducer, { APP_SLICE } from 'Features/App/appSlice'; // 6
import dictionariesSlice, { DICTIONARIES_SLICE } from 'Features/App//Dictionaries/dictionariesSlice';
import mapReducer, { MAP_SLICE } from 'Features/Map/mapSlice';
import filtersReducer, { FILTERS_SLICE } from 'Features/Filters/filtersSlice';
import filtersSliceMonitoring, {FILTERS_SLICE_MONITORING} from "../../Monitoring/Selectors/filtersSliceMonitoring";
import { dcpcApi } from 'Services/api/dcpcApi';
import sidebarReducer, { SIDEBAR_SLICE } from 'Shared/Sidebar/sidebarSlice';
import {EVAPORATION_SLICE} from "../../Constructor/evaporation/evaporationSlice";
import evaporationSlice from "../../Constructor/evaporation/evaporationSlice";
import constructorSlice, {CONSTRUCTOR_SLICE} from "../../Constructor/constructorSlice";
import riverFloodSlice, {RIVER_FLOOD_SLICE} from "../../Constructor/riverFlood/riverFloodSlice";
import rainFloodSlice, {RAIN_FLOOD_SLICE} from "../../Constructor/rainFlood/rainFloodSlice";
import outputFormsSlice, {OUTPUT_FORMS_SLICE} from "../../OutputFormsTemplates/OutputFormsSlice";
import sensorDeviationSlice, {SENSOR_DEVIATION_SLICE} from "../../Calculations/sensorDeviation/SensorDeviationSlice";

/**
 * подключены основные слайсы, которые должны быть всегда:
 * * AUTH_SLICE
 * * APP_SLICE
 * * DICTIONARIES_SLICE
 * * MAP_SLICE
 * * FILTERS_SLICE (Stations and datasource)
 * * dcpcApi из rtk query
 */
export const initialReducers = {
  [AUTH_SLICE]: loginReducer,
  [APP_SLICE]: appReducer,
  [DICTIONARIES_SLICE]: dictionariesSlice,
  [MAP_SLICE]: mapReducer,
  [FILTERS_SLICE]: filtersReducer,
  [FILTERS_SLICE_MONITORING]: filtersSliceMonitoring,
  [SIDEBAR_SLICE]: sidebarReducer,
  [dcpcApi.reducerPath]: dcpcApi.reducer,
  [EVAPORATION_SLICE] : evaporationSlice,
  [CONSTRUCTOR_SLICE] : constructorSlice,
  [RIVER_FLOOD_SLICE] : riverFloodSlice,
  [RAIN_FLOOD_SLICE] : rainFloodSlice,
  [OUTPUT_FORMS_SLICE] : outputFormsSlice,
  [SENSOR_DEVIATION_SLICE] : sensorDeviationSlice
  // 'map'?
};
